import { render, staticRenderFns } from "./Blue.vue?vue&type=template&id=03184c10&scoped=true&"
import script from "./Blue.vue?vue&type=script&lang=js&"
export * from "./Blue.vue?vue&type=script&lang=js&"
import style0 from "./Blue.vue?vue&type=style&index=0&id=03184c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03184c10",
  null
  
)

export default component.exports